export const BILLBOOKING_REPORT_ACTION = 'BILLBOOKING_REPORT_ACTION'
export const BILLBOOKING_REPORT_ACTION_SUCCESS = 'BILLBOOKING_REPORT_ACTION_SUCCESS'
export const BILLBOOKING_REPORT_ERROR_ACTION = 'BILLBOOKING_REPORT_ERROR_ACTION'

